import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ssApiService } from 'app/services/ss-api.service';
import { DesignerInstructionsRequest } from '../../../models/ss-api/requests/designer.instructions.request';
import { GlobalServices } from 'app/services/global.service';
import { xToastr, ToastrTypes } from 'app/shared/Toastr';
import Swal from 'sweetalert2';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'thank-you',
    templateUrl: './thank-you.component.html',
    styleUrls: ['./thank-you.component.scss'],
})
export class ThankYouComponent implements OnInit, OnDestroy {

    IsBusy: boolean = true;

    chooseUser: boolean = true;
    designerKey: boolean = false;

    // DATA SUBSCRIPTION VARIABLES
    paramsSubscribe: any;
    marketTag: string = '';

    // key
    licenseKey: string = 'loading';
    firstName: string = '';

    // designer
    DesignerName: string;
    DesignerEmail: string;

    @ViewChild('emailField') emailField: ElementRef;

    constructor(private router: Router, private api: ssApiService, private route: ActivatedRoute, private gb: GlobalServices,
        private titleService: Title) {

    }

    ngOnInit(): void {
        this.GetFirstLicenseKey();
        this.firstName = this.gb.FirstName;
        this.titleService.setTitle('Structure Studios Account');
    }

    isVizterraName(): boolean {
        if(window.location.href.indexOf("vizterra") > -1) {
            return true;
         }
         else{
             return false;
         }
    } 

    ngOnDestroy() {

    }


    private GetFirstLicenseKey() {

        this.IsBusy = true;

        let subscription = this.api.GetFirstLicenseKey().subscribe(
            (response) => {
                subscription.unsubscribe();
            //if (!response.Result) {
            //    window.location.href = 'http://www.structurestudios.com';
            //}

            if (response.Result) {
              this.licenseKey = response.Data;
            }

            this.IsBusy = false;

            },
            (error) => {
                subscription.unsubscribe();
                this.IsBusy = false;
            });

    }

    SendEmail() {

        if (this.DesignerName == '' || this.DesignerName == undefined) {
            xToastr.ShowToast(ToastrTypes.Error, 'Form Incomplete', 'Please provide the Name of your designer in the form.');
            return;
        }

        if (!this.emailField.nativeElement.classList.contains('ng-valid')) {
            xToastr.ShowToast(ToastrTypes.Error, 'Invalid Email', 'Please provide a valid email address.');
            return;
        }

        this.IsBusy = true;

        let request = new DesignerInstructionsRequest();
        request.Email = this.DesignerEmail;
        request.Name = this.DesignerName;
        request.LicenseKey = this.licenseKey;

        let subscription = this.api.SendLicenseKeyInstructionsToDesignerEmail(request).subscribe(
            (response) => {

                subscription.unsubscribe();

                if (!response.Result) {
                    xToastr.ShowToast(ToastrTypes.Error, 'Error Sending Email', response.Message);
                    this.IsBusy = false;
                    return;
                }

                // show result
                Swal.fire(
                    {
                        title: 'Success',
                        text: 'An email has been sent to ' + request.Name + ' at ' + request.Email,
                        icon: 'success',
                        showCancelButton: false,
                        showConfirmButton: true,

                    })
                    .then(() => {
                        return new Promise((resolve, reject) => {
                            // this.router.navigate(["Dashboard"]);
                            window.location.href = 'account';
                            resolve('');
                        });
                    }, () => { }); // keep this line to prevent promise error;

                this.IsBusy = false;

            },
            (error) => {
                xToastr.ShowToast(ToastrTypes.Error, 'Error Sending Email', error);
                this.IsBusy = false;
            });
    }

    isEmpty(obj): boolean {
        for (let key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    chooseMe() {

        this.IsBusy = true;

        let subscription = this.api.LicenseAssigToLoggedinUser(this.licenseKey).subscribe(
            async (response) => {

                this.IsBusy = false;
                subscription.unsubscribe();

                if (!response.Result) {
                    xToastr.ShowToast(ToastrTypes.Error, 'Error', response.Message);
                    return;
                } else {
                    this.setUserChosen();
                }

            },

            (error) => {
                this.IsBusy = false;
                xToastr.ShowToast(ToastrTypes.Error, 'Error', error);
            });

    }

    chooseDesigner() {
        this.designerKey = true;
        this.setUserChosen();
    }

    setUserChosen() {
        this.chooseUser = false;
    }

    switchDesignerKey() {
        this.designerKey = !this.designerKey;
	}

}
